import styled from 'styled-components';
import {
    Form,
    Input,
    Button,
    Collapse,
    Card,
    Divider,
    Typography,
    DatePicker,
    Table,
    Radio,
    Checkbox,
    Select
} from 'antd';

const { Panel } = Collapse;
const { Title, Text } = Typography;
const { TextArea } = Input;
const { Option } = Select;

// Define a stylish font (using Google Fonts example)
const stylishFont = "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";

export const EmployeesContainer = styled.div`
  padding: 32px;
  background-color: #f8fafc;
  font-family: ${stylishFont};
`;

export const MainCard = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  border: none;
  overflow: hidden;
  
  .ant-card-head {
    border-bottom: 1px solid #f0f0f0;
    background: linear-gradient(90deg, #f8fafc 0%, #ffffff 100%);
    
    .ant-card-head-title {
      font-size: 1.5rem;
      font-weight: 600;
      color: #1e293b;
      padding: 16px 0;
    }
  }
`;

export const CustomCollapse = styled(Collapse)`
  background: transparent;
  border: none;
  font-family: ${stylishFont};
  
  .ant-collapse-item {
    margin-bottom: 20px;
    border-radius: 12px !important;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border: 1px solid #e2e8f0;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    
    &:hover {
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
      transform: translateY(-2px);
    }
  }
  
  .ant-collapse-header {
    padding: 20px 24px !important;
    background: #ffffff;
    font-weight: 600;
    font-size: 1.125rem;
    color: #1e293b;
    letter-spacing: -0.01em;
    
    .ant-collapse-arrow {
      font-size: 1rem;
      color: #64748b;
    }
  }
  
  .ant-collapse-content {
    border-top: 1px solid #f1f5f9;
    background: #ffffff;
  }
  
  .ant-collapse-content-box {
    padding: 28px !important;
  }
`;

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const PanelIcon = styled.span`
  font-size: 1.25rem;
  color: #3b82f6;
  display: flex;
  align-items: center;
`;

export const SectionForm = styled(Form)`
  .ant-form-item {
    margin-bottom: 20px;
  }
  
  .ant-form-item-label {
    font-weight: 500;
    font-size: 0.9375rem;
    color: #475569;
    
    > label {
      font-family: ${stylishFont};
      height: auto !important;
      
      &:not(.ant-form-item-required)::before {
        display: none !important;
      }
    }
  }
  
  .ant-form-item-explain {
    font-size: 0.8125rem;
    margin-top: 6px;
  }
`;

export const FormDivider = styled(Divider)`
  margin: 28px 0 !important;
  color: #475569;
  font-weight: 600;
  font-size: 1rem;
  font-family: ${stylishFont};
  border-top-color: #e2e8f0;
  
  &::before, &::after {
    border-top: 1px solid #e2e8f0 !important;
  }
`;

export const FormInput = styled(Input)`
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 0.9375rem;
  border: 1px solid #cbd5e1;
  transition: all 0.2s;
  
  &:hover {
    border-color: #94a3b8;
  }
  
  &:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
  }
`;

export const IconInput = styled(Input)`
  .ant-input-prefix {
    margin-right: 10px;
    display: flex;
    align-items: center;
    color: #94a3b8;
  }
  
  .ant-input-affix-wrapper {
    height: auto;
    padding: 12px 16px;
    border-radius: 8px;
    font-size: 0.9375rem;
    border: 1px solid #cbd5e1;
    transition: all 0.2s;
    
    &:hover {
      border-color: #94a3b8;
    }
    
    &:focus-within {
      border-color: #3b82f6;
      box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
    }
  }
`;

export const IconTextArea = styled(TextArea)`
  .ant-input-prefix {
    margin-right: 10px;
    display: flex;
    align-items: center;
    color: #94a3b8;
  }
  
  .ant-input {
    padding: 12px 16px;
    border-radius: 8px;
    font-size: 0.9375rem;
    border: 1px solid #cbd5e1;
    transition: all 0.2s;
    min-height: 120px !important;
    
    &:hover {
      border-color: #94a3b8;
    }
    
    &:focus {
      border-color: #3b82f6;
      box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
    }
  }
`;

export const SubmitButton = styled(Button)`
  width: 100%;
  max-width: 320px;
  height: 48px;
  font-weight: 600;
  font-size: 1rem;
  margin-top: 24px;
  border-radius: 8px;
  background: linear-gradient(90deg, #3b82f6 0%, #2563eb 100%);
  border: none;
  color: white;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

export const NameSection = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

export const AddressSection = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 28px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

export const StyledTable = styled(Table)`
  .ant-table {
    border-radius: 12px;
    overflow: hidden;
    font-family: ${stylishFont};
  }
  
  .ant-table-thead > tr > th {
    background-color: #f1f5f9;
    font-weight: 600;
    font-size: 0.9375rem;
    color: #1e293b;
    padding: 16px;
    border-bottom: none;
  }

  .ant-table-tbody > tr > td {
    padding: 14px 16px;
    font-size: 0.9375rem;
    color: #334155;
    border-bottom: 1px solid #f1f5f9;
  }
  
  .ant-table-tbody > tr:hover > td {
    background: #f8fafc !important;
  }
  
  .ant-table-pagination.ant-pagination {
    margin: 24px 0 0 0;
  }
`;

// Additional stylish components
export const SectionTitle = styled(Title)`
  &.ant-typography {
    font-family: ${stylishFont};
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 1.5rem !important;
  }
`;

export const HintText = styled(Text)`
  &.ant-typography {
    display: block;
    font-size: 0.875rem;
    color: #64748b;
    margin-top: 8px;
    font-family: ${stylishFont};
  }
`;

export const StyledSelect = styled(Select)`
  .ant-select-selector {
    padding: 12px 16px !important;
    border-radius: 8px !important;
    font-size: 0.9375rem;
    border: 1px solid #cbd5e1 !important;
    height: auto !important;
    
    &:hover {
      border-color: #94a3b8 !important;
    }
  }
  
  .ant-select-arrow {
    color: #94a3b8;
  }
`;

export const StyledDatePicker = styled(DatePicker)`
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 0.9375rem;
  border: 1px solid #cbd5e1;
  width: 100%;
  
  &:hover {
    border-color: #94a3b8;
  }
  
  &:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
  }
`;

export const UploadContainer = styled.div`
  margin-top: 24px;
  padding: 16px;
  border: 1px dashed #d9d9d9;
  border-radius: 2px;
  text-align: center;
  background: #fafafa;
`;
